import * as actionTypes from './actionTypes'

export const signUpAction = (signUp) => {
    return {
        type: actionTypes.SIGN_UP_USER,
        signUp
    }
}